import { getDomain } from "./helpers.js";
import axios from "axios";
import store from "../store";

export async function loadOptions(type) {
    const url =
        getDomain() + `/odata/smlookup?$filter=contains(type, '${type}')`;

    const response = await axios.get(url, {
        headers: {
            Authorization: store.state.authentication.token,
        },
    });

    return response.data.value;
}

export default { loadOptions };
